import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import mixing from "../../Assets/mixing.png";
import evaporation from "../../Assets/evaporation.png";
import cutting from "../../Assets/cutting.png";
import packaging from "../../Assets/packaging.png";
import productionFlow from "../../Assets/production-flow.webp";
import oceanImg from "../../Assets/ocean-sustainability.webp";
import Tilt from "react-parallax-tilt";
import Seo, { breadcrumbSchema, privateLabelServiceSchema, webPageSchema } from "../Seo/Seo";

function Production() {
  return (
    <div className="production-section page-top-settings primary left mobile-type">
    <Seo
      title="Laundry Detergent Sheets Factory & Packaging Process | Klean Leaf"
      description="See how Klean Leaf supports laundry detergent sheet manufacturing, custom formulation, cutting, private label packaging, documents, and logistics."
      path="/production"
      schema={[
        privateLabelServiceSchema,
        webPageSchema({
          name: "Laundry Detergent Sheets Factory & Packaging Process | Klean Leaf",
          description: "See how Klean Leaf supports laundry detergent sheet manufacturing, custom formulation, cutting, private label packaging, documents, and logistics.",
          path: "/production",
          primaryImage: productionFlow,
        }),
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Production", path: "/production" },
        ]),
      ]}
    />
    <Container>
      <Row className="production-intro" style={{ textAlign: "center" }}>
        <h1>Laundry Detergent Sheets Factory</h1>
        <p className="page-title production-intro-subtitle">
          Production and Packaging Process
        </p>
        <p className="page-subtitle">Custom formulation, sheet casting, cutting, and private label packing</p>
      </Row>

      <Row>
        <Col md={12} className="production-flow-img-wrapper center">
          <Tilt>
            <img
              src={productionFlow}
              className="production-flow-img"
              alt="Laundry detergent sheet manufacturing process flow"
              loading="lazy"
              decoding="async"
            />
          </Tilt>
        </Col>
      </Row>

      <Row>
        <Col md={12} className="my-4">
          <p className="production-flow-text left">
            Klean Leaf supports private label <Link className="product-context-link" to="/products/laundry-detergent-sheets">laundry detergent sheet</Link> production from formula review through packaging and shipment. The process can include custom scent direction, fragrance-free formulas, perforated sheet formats, paper bag or paper box packaging, and bulk refill cartons.
          </p>
        </Col>
      </Row>

      <Row className="column-reverse">
        <Col md={6} className="production-text">
          <h2>Mixing and Formula Preparation</h2>
          <p>
            The laundry detergent sheet manufacturing process starts with measured ingredient blending. Formula requirements can be reviewed for your target market, including scent direction, fragrance-free positioning, sheet feel, and performance expectations.
          </p>
          <p>
            Compare <Link className="product-context-link" to="/products/3-in-1-enzyme-laundry-detergent-sheets">3-in-1 enzyme laundry detergent sheets</Link> and <Link className="product-context-link" to="/products/pva-free-laundry-detergent-sheets">PVA-free laundry detergent sheets</Link> as starting points for your formula discussion.
          </p>
        </Col>
        <Col md={6} className="production-image">
          <Tilt>
            <img src={mixing} className="" alt="Laundry detergent sheet formula mixing stage" loading="lazy" decoding="async" />
          </Tilt>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="production-image right">
          <Tilt>
            <img src={evaporation} className="" alt="Laundry detergent sheet evaporation and formation stage" loading="lazy" decoding="async" />
          </Tilt>
        </Col>
        <Col md={6} className="production-text">
          <h2>Evaporation and Sheet Formation</h2>
          <p>
            The blended detergent mixture moves through evaporation and sheet formation. This stage helps create compact detergent sheets that are ready for sizing, perforation planning, and quality review.
          </p>
        </Col>
      </Row>

      <Row className="column-reverse">
        <Col md={6} className="production-text">
          <h2>Cutting and Perforation</h2>
          <p>
            After sheet formation, detergent sheets are cut to the required size. Perforated formats can help brands market half-sheet or full-sheet usage depending on load size, price positioning, and customer instructions.
          </p>
        </Col>
        <Col md={6} className="production-image">
          <Tilt>
            <img src={cutting} className="" alt="Laundry detergent sheet cutting and perforation stage" loading="lazy" decoding="async" />
          </Tilt>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="production-image right">
          <Tilt>
            <img src={packaging} className="" alt="Private label laundry detergent sheet packaging stage" loading="lazy" decoding="async" />
          </Tilt>
        </Col>
        <Col md={6} className="production-text">
          <h2>Private Label Packaging</h2>
          <p>
            Finished sheets are packed into your selected format, including paper bags, paper boxes, custom packaging, or loose bulk cartons for refill shops. Klean Leaf can support artwork integration, packaging samples, carton planning, logistics, and delivery coordination.
          </p>
        </Col>
      </Row>

      
      <Row className="production-summary">
        <Col md={12} className="my-4">
          <img src={oceanImg} className="img-fluid" alt="Compact laundry sheet sustainability positioning" loading="lazy" decoding="async" />
        </Col>
        <Col>
          <p className="production-flow-text left">
            Business buyers can request available documents such as ISO 9001, ISO 22716 GMP, OECD 301B, MSDS, and optional third-party testing support. Typical production lead time is 45–60 days for first private label orders.
          </p>
          <div className="cta-row">
            <Link to="/products" className="secondary-btn">See What We Manufacture</Link>
            <Link to="/contact" className="primary-btn">Start Your Private Label Project</Link>
          </div>
        </Col>
      </Row>
    </Container>
    </div>
  );
}

export default Production;
